module.exports = __webpack_public_path__ + "img/indexBG.3a0a7220.png";